import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=1abdacf4&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=ts&"
export * from "./textarea.vue?vue&type=script&lang=ts&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=1abdacf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdacf4",
  null
  
)

export default component.exports